import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
// import { IoIosArrowBack } from "react-icons/io";
import { Loader } from 'react-overlay-loader';
export default function Svgs() {
    const navigate = useNavigate()
    const [loader, setLoader] = useState(false);
    // const [token] = useState("");
    const [response, setResponse] = useState([]);
    const [svgid, setSvgid] = useState('');
console.log('svgid',svgid)
    console.log('response',response)
    const [selectedIdx, setSelectedIdx] = useState(null);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
   
    // Access the parameters
    const familyLastName = queryParams.get('family_last_name');
    const slogan = queryParams.get('slogan');
    const colour_code = queryParams.get('colour_code');
    const svgCategoryId = queryParams.get('svg_category_id');
    const token = queryParams.get('token');

    localStorage.setItem("token", token)
    const data = JSON.stringify({ familyLastName, slogan, colour_code, svgCategoryId });
    // Save the string to localStorage with the key "data"
    localStorage.setItem("data", data);
    // Retrieve data from localStorage
    const localStorageData = localStorage.getItem("data");
    const parsedData = localStorageData ? JSON.parse(localStorageData) : null;
    // Create an object with the extracted parameters
    const convertToSnakeCase = (key) => key.replace(/[A-Z]/g, (match) => `_${match.toLowerCase()}`);
    const paramsObject = {
        familyLastName,
        slogan,
        colour_code,
        svgCategoryId,
        svgid,
        token,
    };

    // Convert keys to snake_case
    const snakeCaseObject = {};
    for (const key in paramsObject) {
        snakeCaseObject[convertToSnakeCase(key)] = paramsObject[key];
    }

    // Convert the object into URLSearchParams
    const params = new URLSearchParams(Object.entries(snakeCaseObject));

    // Construct the URL with the parameters
    const url = `https://fhbapi.devssh.xyz/?${params.toString()}`;



    // Initialize formData with data from localStorage or query parameters
    const [formData] = useState({
        family_last_name: parsedData ? parsedData.familyLastName : familyLastName,
        slogan: parsedData ? parsedData.slogan : slogan,
        colour_code: parsedData ? parsedData.colour_code : colour_code,
        svg_category_id: parsedData ? parsedData.svgCategoryId : svgCategoryId,
        url: url

    });

    

    const MovetoNextpage = () => {
        navigate('/logocategory', { state: { url: url } })
    }


    const handleBoxClick = (index,item) => {
        console.log('index===',index,item?.id)
        setSvgid(item?.id)
        setSelectedIdx(index === selectedIdx ? null : index);
    };

    useEffect(() => {
        window.scroll(0, 0)
        postData()

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formData])


    const postData = async () => {

        setLoader(true)
        window.scroll(0, 0)
        try {
            const response = await fetch(`https://fhbapi.devssh.xyz/api/v1/logo_details/get_svgs_webview/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });
            const data = await response.json();
            setLoader(false)
            setResponse(data?.data);
        } catch (error) {
            setLoader(false)
            console.error('Error fetching data:', error);
        }
    };


    return (

        <>
            {loader === true ? <Loader fullPage loading /> : null}

            <main className="main_wrapper overflow-hidden">
                <section className="shop__page__wrap ">
                    <div className="container-fluid full__width__padding">
                        <div className="row ">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                                <div className="tab-content" id="myTabContent" data-aos="fade-up">

                                    <div className="tab-pane fade active show" id="list_view">
                                        <div className="row d-flex justify-content-center align-items-center flex-column">

                                            {response?.map((item, index) => (
                                                <div key={item.id} className='col-xl-3 col-lg-3 col-md-4 col-sm-12 column__custom__class' onClick={() => handleBoxClick(index,item)}>
                                                    <div className={`gridarea__wraper product__grid ${index === selectedIdx ? 'clicked' : ''}`}>
                                                        <div className="gridarea__img">
                                                            {/* Display SVG code using dangerouslySetInnerHTML */}

                                                            <div dangerouslySetInnerHTML={{ __html: item.svg_code.replace(/ns0:/g, '') }} />

                                                        </div>
                                                    </div>
                                                </div>
                                            ))}

                                        </div>
                                        <div className="fixed-buttons d-flex justify-content-center align-item-center">
                                            <button onClick={() => postData()} className="btn btn-secondary mx-1 fixed-width-btn-sec">Re-Generate</button>
                                            <button onClick={() => MovetoNextpage()} className="btn btn-primary fixed-width-btn-prm ">Next</button>
                                        </div>
                                    </div>

                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </main>

        </>
    )
}
